import { Avatar, Divider, Grid, Typography } from '@mui/material';
import { IEquipmentSingleOrder } from 'API';
import { ListDivider } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { GreenVi, RedAlert, Warning } from 'Images';

interface IOrderItemProps {
  item: IEquipmentSingleOrder;
  isSuppliedOrPartial: boolean;
}

export const EquipmentItem = ({
  item,
  isSuppliedOrPartial,
}: IOrderItemProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  const hasNotes =
    item.itemNote || item.quantityNote || item.isSupplied !== undefined;

  return isDesktop ? (
    <>
      <Grid container alignContent={'center'} sx={{ minHeight: '72px' }}>
        <Grid
          container
          item
          xs={6}
          md={isSuppliedOrPartial ? 4 : 5}
          alignContent={'center'}
        >
          <Typography variant='body3'>{item.itemName}</Typography>
        </Grid>
        <Grid container item xs={6} md={2}>
          <Grid
            container
            item
            justifyContent={'center'}
            sx={{
              maxWidth: '53px',
              backgroundColor: 'purple2.shade_100',
              padding: '10px 15px',
            }}
          >
            <Typography variant='body2'>{item.quantity}</Typography>
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={6}
          md={isSuppliedOrPartial ? 4 : 5}
          alignContent={'center'}
          p={0}
        >
          {item.itemNote && (
            <Typography
              width='100%'
              sx={{ display: 'flex', mr: '10px' }}
              variant='body3'
            >
              {item.itemNote}
            </Typography>
          )}
          {item.quantityNote && (
            <Typography
              width='100%'
              sx={{ display: 'flex', mr: '10px' }}
              variant='body3'
            >
              {item.quantityNote}
            </Typography>
          )}
        </Grid>

        {item.isSupplied !== undefined && (
          <Grid container item xs={6} md={2} sx={{ flexFlow: 'unset' }}>
            <Avatar
              src={item.isSupplied ? GreenVi : RedAlert}
              alt=''
              sx={{
                width: '16px',
                height: '16px',
                alignSelf: 'center',
                mr: '6px',
                display: 'inline-flex',
              }}
            />
            <Typography
              width='100%'
              sx={{ display: 'flex', alignItems: 'center' }}
              variant='body3'
            >
              {item.isSupplied
                ? dictionary.orderDialog.isSupplied
                : dictionary.orderDialog.isNotSupplied}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid>
        <ListDivider />
      </Grid>
    </>
  ) : (
    <Grid
      container
      justifyContent={'space-between'}
      sx={{
        padding: 0,
        mt: 2,
      }}
    >
      <Grid
        container
        justifyContent={'space-between'}
        sx={{
          width: '100%',
          padding: '0',
          pb: 2,
          borderBottom: '1px solid',
          borderColor: 'primary.shade_100',
        }}
      >
        <Grid container item xs={9} alignItems={'center'}>
          <Typography variant='body6'>{item.itemName}</Typography>
        </Grid>
        <Grid
          container
          item
          justifyContent={'center'}
          alignContent={'center'}
          xs={3}
          sx={{
            maxWidth: '56px',
            height: '40px',
            backgroundColor: 'purple2.shade_100',
            padding: 1,
          }}
        >
          <Typography textAlign={'center'} variant='body5'>
            {item.quantity}
          </Typography>
        </Grid>
        {item.isSupplied !== undefined && (
          <Grid
            xs={12}
            container
            item
            sx={{
              padding: '16px 0',
              flexFlow: 'unset',
            }}
          >
            <Avatar
              src={item.isSupplied ? GreenVi : RedAlert}
              alt=''
              sx={{
                width: '16px',
                height: '16px',
                alignSelf: 'center',
                mr: '6px',
                display: 'inline-flex',
              }}
            />
            <Typography
              width='100%'
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              {item.isSupplied
                ? dictionary.orderDialog.isSupplied
                : dictionary.orderDialog.isNotSupplied}
            </Typography>
          </Grid>
        )}
      </Grid>

      {(item.itemNote || item.quantityNote) && (
        <Grid sx={{ padding: 3 }}>
          {item.itemNote && (
            <>
              <Avatar
                src={Warning}
                alt=''
                sx={{
                  width: '16px',
                  height: '16px',
                  alignSelf: 'center',
                  mr: '6px',
                  display: 'inline-flex',
                }}
              />
              <Typography width='100%' sx={{ display: 'flex' }}>
                {item.itemNote}
              </Typography>
            </>
          )}

          {item.quantityNote && (
            <>
              <Avatar
                src={Warning}
                alt=''
                sx={{
                  width: '16px',
                  height: '16px',
                  alignSelf: 'center',
                  mr: '6px',
                  display: 'inline-flex',
                }}
              />
              <Typography width='100%' sx={{ display: 'flex' }}>
                {item.quantityNote}
              </Typography>
            </>
          )}
        </Grid>
      )}
    </Grid>
  );
};
